export class Skill {
  public name: string;
  public exp: string;

  constructor(name: string, exp: string) {
    this.name = name;
    this.exp = exp;
  }
}
